import * as Yup from "yup";

export const loginFormValidationSchema = Yup.object().shape({
  password: Yup.string().required("O campo senha é obrigatório").trim(),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "As senhas digitadas não coincidem"
  ),
});
